module.exports = __webpack_public_path__ + "static/media/checkbox-checkmark.5535dcaf.svg";